<div class="drawer-content-screen">
  <div class="drawer-content-screen__title">{{ 'addGroups' | translate }}</div>
  <div class="drawer-content-screen__body">
    @if (isLoading) {
      <div class="pt-2">
        <ngx-skeleton-loader
          [count]="11"
          [theme]="{
            height: '24px',
            width: '100%',
          }"></ngx-skeleton-loader>
      </div>
    }

    @if (isError) {
      <div class="h-full w-full">
        <app-something-went-wrong
          [showPicture]="false"
          (retryEmitter)="ngOnInit()"></app-something-went-wrong>
      </div>
    }

    @if (!isLoading && !isError) {
      <div>
        <span class="example-list-section">
          <ul>
            @if (!existedGroups.length) {
              <li>No groups</li>
            }

            @for (group of existedGroups; track group) {
              <li>
                <mat-checkbox
                  color="primary"
                  [checked]="isChecked(group.groupId)"
                  (change)="addGroupToEmails($event.checked, group.groupId)">
                  {{ group.group }}
                </mat-checkbox>
              </li>
            }
          </ul>
        </span>
      </div>
    }
  </div>
  <div class="flex w-full justify-end">
    <button
      mat-flat-button
      [disabled]="isSavingGroups"
      color="primary"
      (click)="ok()">
      <app-loading-button
        text="{{ 'save' | translate }}"
        [loading]="isSavingGroups"></app-loading-button>
    </button>
  </div>
</div>
